import { render } from "./LoadPage.vue?vue&type=template&id=5296f641&scoped=true"
import script from "./LoadPage.vue?vue&type=script&lang=js"
export * from "./LoadPage.vue?vue&type=script&lang=js"

import "./LoadPage.vue?vue&type=style&index=0&id=5296f641&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5296f641"]])

export default __exports__